import React, { Component } from "react"
import styled from "styled-components"
import { SECONDARY_TEXT, ACTIVE_TEXT } from "./consts/colors"
import { TinyButtonWhite } from "./Button"

const Step = styled.div`
  position: relative;
  z-index: 3;
  width: ${props => props.width};
  max-width: 300px;
  min-height: 300px;
  top: ${props => props.positionTB};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 15px;
  padding: 25px 25px;
  border-radius: 8px;
  border 2px solid #D9DADF;
  h1 {
    margin-bottom: 25px;
  }
  h3 {
    margin-bottom: 20px;
  }
  p {
    margin-bottom: 10px;
  }
  @media screen and (max-width: 980px) {
    max-width: 500px;
    min-height: 220px;
  }
  @media screen and (max-width: 768px) {
    padding: 0px 25px;
  }
  @media screen and (max-width: 615px) {
    padding: 0px 10px;
  }
`

export default Step



// WEBPACK FOOTER //
// ./src/components/Step.js